import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const filesGenerateWOPITokenMutationAtom = createMutationAtomFactory(
  'office.generateWOPIToken',
  (params: { fileId: string; permission?: 'Read' | 'Write' }) => ({
    filesGenerateWOPIToken: {
      __args: {
        input: {
          fileId: params.fileId,
          permission: params.permission || 'Write',
        },
      },
      token: {
        token: true,
        expiresAt: true,
        permission: true,
        fileId: true,
        userId: true,
        userName: true,
        userEmail: true,
      },
    },
  }),
);
